const waitForRef = (refName, context, interval = 100, timeout = 3000) => {
  return new Promise((resolve, reject) => {
    const startTime = Date.now()

    const checkRef = () => {
      const ref = context.$refs[refName]
      if (ref) {
        resolve(ref)
      } else if (Date.now() - startTime > timeout) {
        reject(new Error(`Timeout waiting for $refs['${refName}']`))
      } else {
        setTimeout(checkRef, interval)
      }
    }

    checkRef()
  })
}

export { waitForRef }
